import { useCallback } from 'react';
import { usePlatformMeta, generateWidgetData } from '@invent/platform-api';

export function useWidgetDataGenerator() {
  const platformMeta = usePlatformMeta();

  const widgetDataGenerator = useCallback(
    (name: string, widgetId: string | number) => {
      return generateWidgetData(platformMeta)(name, widgetId);
    },
    [platformMeta]
  );
  return widgetDataGenerator;
}
